import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table'
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import '../../../../../node_modules/react-datetime/css/react-datetime.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
import moment from 'moment';
import { getSchoolGrades, groupBy, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, showFile,
    convertTwoDecimalPoint, getSessionStartEndDates, _addNotificationError, numberParce, getLastMonthStartEndDates } from '../../../../server/util'
import { get } from '../../../../server/actions';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
var _ = require('lodash');
class SalesReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            selectedDates:{
                startDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).startOf('month'),
                endDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).endOf('month')
            },
            priceFilter: 'all'
        }
    }
    componentDidMount = () => {
        let selectedDates = this.state.selectedDates
        this.getSalesData(selectedDates.startDate, selectedDates.endDate)
    }
    btnExportExcelOnClick = (e) => {
        const btn = document.getElementById('btnExportExcel');
        if (btn) {
            btn.click();
        }
    }
    onChangeDateRange=(startDate,endDate)=>{  
        let _selectedDate={startDate:startDate,endDate:endDate}
        this.setState({selectedDates:_selectedDate},
            this.getSalesData(startDate, endDate)
        );
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.state.activeMonth !== nextProps.activeMonth) {
            let _selectedDate = {
                startDate: moment((nextProps.activeMonth || moment()), 'YYYYMM').startOf('month'),
                endDate: moment((nextProps.activeMonth || moment()), 'YYYYMM').endOf('month')
            }
            this.setState({ selectedDates: _selectedDate }, this.getSalesData(_selectedDate.startDate, _selectedDate.endDate))
        }
    }

    getSalesData = (startDate, endDate) => {
        let _self = this
        let isPdf = false
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let dateStart = moment(startDate).startOf('D');
        let dateEnd = moment(endDate).endOf('D');

        get(`/reports/salesReport/${userInfo.schoolId}?startDt=${moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDt=${ moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss")}&isExport=${isPdf}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();
            }).then(data => {
                data.response.map((item)=>{
                    item["category"] = (["MEAL","BREAKFAST","SNACK","DINNER"].includes(item.category.toUpperCase()))? "ENTREE" : item.category.toUpperCase();
                })
                this.setState({ data: data.response })
            console.log("Sales Data: ", data.response)
        }).catch(error => {
            console.log("Sales Error: ", error);
        })
    }

    downloadPDF = (isPdf) => { 
        let filename = 'Sales_Report.pdf'
        const dates = this.state.selectedDates
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        get(`/reports/salesReport/${userInfo.schoolId}?startDt=${moment(dates.startDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDt=${ moment(dates.endDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&isExport=${isPdf}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response);
            }
            return response;
        }).then(res => {
            if (isPdf) {
                return res.blob();
            } else { 
                return res.json();
            }
        }).then(blob => {
            showFile(blob, filename)
        }).catch(error => {
            console.log("Download Error: ", error);
        })
    }


    getColumns = () => {
        let columns = [            
            { 
                Header: "Category", 
                accessor:'category',
                width: 200,
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                Filter: ({ filter, onChange }) => {
                    return (
                        <select className="form-control"
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : 'all'}
                        >
                            <option value={''}>{''}</option>
                            {_.map(
                                _.uniq(
                                    _.map(this.state.data, function (obj) {
                                        return (["MEAL","BREAKFAST","SNACK","DINNER"].includes(obj.category.toUpperCase()))? "ENTREE" : obj.category.toUpperCase();
                                    })
                                )).map(item =>
                                    <option value={item}>{item}</option>
                                )
                            }
                        </select>                      
                    )
                }
            },            
            { Header: "Item Name", accessor: "itemName" },
            { 
                Header: "Count", 
                width: 200, 
                style: { textAlign: 'center' },
                filterable:false, 
                accessor: "count",
                Footer: (props) => {
                    const { data } = props;
                    const tempList = (data).map(d => d._original);
                    const _sum = tempList.reduce((prev, cur) => numberParce(prev) + numberParce(cur.count), 0)
                   return <div style={{ textAlign: "center" }}>Total:  {_sum}</div>
                }
             },
            
        ];
        return columns
    }
    buildDataFormatForExport = () => {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        const cols=this.getColumns();
        return (
            [{
                columns: cols.map(col=>{
                    return {title:col.Header}
                }),
                data: this.state.data.map(item => {
                    return cols.map(col=>{
                        return {value:item[col.accessor]}
                    })
                })
            }]
        )
    }
    render() {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        return (<Fragment>
            <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
            <div className="panel panel-p1 panel-primary">
                <div className="panel-heading text-center">
                    <h3 className="panel-title" style={{ display: 'inline' }}>Sales Report</h3>
                   
                    <div style={{
                        display: 'inline-block',
                        backgroundColor: 'transparent',
                        marginTop: '-7px',
                        float: 'right',
                        borderRadius: '3px'
                    }}>
                        <div className="btn-group">
                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                        onClick={() => { this.downloadPDF(true); }}
                                        target='_blank'
                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                </li>
                                <li>
                                    <TmExportExcel id="saleReport" 
                                        name={"Sales Report"}
                                        filename={"Sales Report"}
                                        element={<a title="Click to Download Excel"  id="saleReport"
                                        style={{ 
                                        display: 'block',  
                                        padding: '3px 20px',
                                        clear: 'both',
                                        fontWeight: '400',
                                        lineHeight: 1.42857143,
                                        color: '#333',
                                        whiteSpace: 'nowrap',
                                        cursor:'pointer'
                                        }}
                                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                                        dataSet={this.buildDataFormatForExport()}
                                    /> 
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <div className='row' style={{marginTop:'5px', marginBottom:'5px', fontSize:'16px'}}>
                        <div className='col-md-2'>
                            <label>Select date range:</label>
                        </div>
                        <div className='col-md-4'>
                            <DateTimeRangePicker
                                startDate={this.state.selectedDates.startDate} 
                                endDate={this.state.selectedDates.endDate}
                                isReport={false}
                                applyCallback={(event,picker)=>{
                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                }}                                    
                                isDateShow={true}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <ReactTable className="-striped -highlight"
                            filterable
                                data={this.state.data}
                                columns={this.getColumns()}
                                defaultPageSize={10}
                            />
                        </div>
                    </div>
                </div>
            </div>


        </Fragment>);
}
}

export default SalesReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/sales.jsx